import React, { useState } from "react";
import { Button, Form, Modal, Row } from "reactstrap";
import { useDispatch } from "react-redux";
import { bankProxyAdd } from "../../../redux/slices/bankProxySlice";
import CustomeButton from "../../../components/Custom/Forms/CustomeButton/CustomeButton";
import ControlledInput from "../../../components/Custom/Forms/Controller/ControlledInput";
import { useForm } from "react-hook-form";
import { responseToaster } from "../../../helperFunctions";

const AddBankProxyModal = (props) => {
  const { onHide, isOpen, onGet } = props;

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    ip_proxy: "",
    label_name: "",
  };

  const onSubmit = async () => {
    try {
      const values = getValues();
      setIsLoading(true);
      const res = await dispatch(bankProxyAdd(values)).unwrap();
      responseToaster(res);
      onClose();
      onGet();
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const { control, getValues, handleSubmit, reset } = useForm({
    defaultValues: initialValues,
  });

  const onClose = () => {
    reset();
    onHide();
  };

  return (
    <Modal
      className="add-manual-payout-modal"
      isOpen={!!isOpen}
      toggle={onClose}
      centered={true}
    >
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="modal-header">
          <h4 className="modal-title mt-0">Add New Bank Proxy</h4>
          <i
            onClick={() => {
              onClose();
            }}
            className="fa-solid fa-xmark"
          ></i>
        </div>
        <div className="modal-body">
          <Row>
            <ControlledInput
              name="label_name"
              label="Label"
              placeholder="Enter Label"
              type="text"
              control={control}
            />
            <ControlledInput
              name="ip_proxy"
              label="Proxy IP"
              type="text"
              placeholder="Enter Proxy IP"
              control={control}
            />
          </Row>
        </div>
        <div className="modal-footer">
          <div className="d-flex justify-content-end button-space">
            <Button className="graybutton" onClick={() => onClose()}>
              Cancel
            </Button>
            <CustomeButton
              type="submit"
              className="submitbutton"
              isButtonLoading={isLoading}
            >
              Submit
            </CustomeButton>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default AddBankProxyModal;
